import React, {useState, useRef, useEffect} from 'react';
import './BubbleTip.css';
import {FontIcon} from "@/app/_components";

interface BubbleTipProps {
    text1: string;
    text2: string;
}

const BubbleTip: React.FC<BubbleTipProps> = ({text1, text2}) => {
    const [isVisible, setIsVisible] = useState(false);
    const bubbleRef = useRef<HTMLDivElement | null>(null);

    // 点击外部区域关闭提示框
    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
            if (bubbleRef.current && !bubbleRef.current.contains(event.target as Node)) {
                setIsVisible(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, []);

    return (
        <div className="bubble-tip-container">
            <button
                className="question-mark-button"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsVisible(!isVisible);
                }}
            >
                <FontIcon
                    icon={'s-ask'}
                    style={{
                        color: '#fff',
                        fontSize: '0.5rem',
                        lineHeight: '0.42rem',
                    }}
                />
            </button>
            {isVisible && (
                <div className="bubble-tip" ref={bubbleRef}>
                    <div className="bubble-tip-arrow"/>
                    <div className="bubble-tip-content">
                        <p>{text1}</p>
                        <p>{text2}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BubbleTip;
